module.exports = __webpack_public_path__ + "img/st.c3055812.svg";